import React from 'react';
import { StepButtons } from '../StepButtons';
import sideImage from 'assets/ttu/ttu-step-2.avif';
import { withLayout } from 'helpers';
import { useTracker } from 'utils/tracking';
import { SideImageContainer } from '../SideImageContainer';
import { WereAvailableDecoration } from '../QuestionDecoration';

function WereAvailableComponent(props) {
  const trackOnce = useTracker();

  return (
    <SideImageContainer sideImage={sideImage} decorationComponent={<WereAvailableDecoration />}>
      <div className="header">
        <StepButtons
          onBack={() => props.history.push(props.prevRoute)}
          onNext={() => {
            trackOnce('lead_question3_available_in_area');
            props.history.push(props.nextRoute);
          }}
        />
      </div>

      <div className="right-content">
        <div className="right-copy">
          <h2 className="blue label state_title">
            Great! We are available in your area
          </h2>

          <p className="subtitle2">
            Let's get you on your way to feeling better
          </p>
        </div>
      </div>
    </SideImageContainer>
  );
}

WereAvailableComponent.title = "We're available in your area";

export default withLayout(WereAvailableComponent);